module.exports = __webpack_public_path__ + "static/media/notification.f71032b6.svg";